<template>
<div style="width:100%">
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/> 
  		<FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<label class="control-label">Dedication message <small>This message will be posted on the inside cover of the bencher (max 150 chars)</small></label>
		<FormRow inline>
			<FormCol field="dedicationMessage" :showLabel="false" />
		</FormRow>
		<br/><br/>
		<FormRow inline v-if="recipientFlag">
			<FormCol field="recipientName" />
			<FormCol field="recipientEmail" />
		</FormRow>
		<FormRow inline v-if="recipent">
			<span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">				
				<span v-if="!recipientFlag">+ Add </span>
				<span v-else>- Remove </span> 
				recipient
				<span v-if="!recipientFlag"> to notify</span>
			</span>
		</FormRow>
	</div>
</div>
</template>
<script lang="ts">
import { defineComponent, type PropType, ref, watch } from 'vue'

export default defineComponent({
  props: {
    recipent: {
      type: Boolean,
      default: true
    }
  },	
  setup() {
	  const inHonorOf = false
	  const recipientFlag = false

	  return {
		  inHonorOf,
		  recipientFlag
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
.control-label {
	padding-top: 3px;
    padding-bottom: 3px;
    display: block;
	margin-bottom: 5px;
	font-size: 14px;
    color: #222;
	line-height: 1.4
}
small {
	font-size: .8em;
	color: #666;
	display: block;
}
</style>